export const formPage = {
    editForm: 'FORM_PAGE.EDIT_FORM',
    shareForm: 'FORM_PAGE.SHARE_FORM',
    pro: 'FORM_PAGE.PRO',
    searchByEmail: 'FORM_PAGE.SEARCH_BY_EMAIL',
    defaultDescription: 'FORM_PAGE.SETTINGS.DEFAULT.DESCRIPTION',
    pinFormTitle: 'FORM_PAGE.SETTINGS.DEFAULT.PIN_FORM.TITLE',
    pinFormDescription: 'FORM_PAGE.SETTINGS.DEFAULT.PIN_FORM.DESCRIPTION',
    reviewPageTitle: 'FORM_PAGE.SETTINGS.DEFAULT.REVIEW_PAGE.TITLE',
    reviewPageDescription: 'FORM_PAGE.SETTINGS.DEFAULT.REVIEW_PAGE.DESCRIPTION',
    brandingTitle: 'FORM_PAGE.SETTINGS.DEFAULT.BRANDING.TITLE',
    brandingDescription: 'FORM_PAGE.SETTINGS.DEFAULT.BRANDING.DESCRIPTION',
    formPurposeTitle: 'FORM_PAGE.SETTINGS.DEFAULT.FORM_PURPOSE.TITLE',
    formPurposeDescription: 'FORM_PAGE.SETTINGS.DEFAULT.FORM_PURPOSE.DESCRIPTION',
    formPurposeSeeDetails: 'FORM_PAGE.SETTINGS.DEFAULT.FORM_PURPOSE.SEE_DETAILS',
    visibilityTitle: 'FORM_PAGE.SETTINGS.VISIBILITY.TITLE',
    visibilityDescription: 'FORM_PAGE.SETTINGS.VISIBILITY.DESCRIPTION',
    visibilityPublic: 'FORM_PAGE.SETTINGS.VISIBILITY.PUBLIC',
    visibilityPrivate: 'FORM_PAGE.SETTINGS.VISIBILITY.PRIVATE',
    visibilityGroupsTitle: 'FORM_PAGE.SETTINGS.VISIBILITY.GROUPS.TITLE',
    visibilityGroups0: 'FORM_PAGE.SETTINGS.VISIBILITY.GROUPS.GROUPS0',
    visibilityGroups1: 'FORM_PAGE.SETTINGS.VISIBILITY.GROUPS.GROUPS1',
    visibilityAddOrRemove: 'FORM_PAGE.SETTINGS.VISIBILITY.ADD_OR_REMOVE',
    linksDescription: 'FORM_PAGE.SETTINGS.LINKS.DESCRIPTION',
    linksChangeSlug: 'FORM_PAGE.SETTINGS.LINKS.CHANGE_SLUG',
    linksCustomDomainLink: 'FORM_PAGE.SETTINGS.LINKS.CUSTOM_DOMAIN_LINK',
    linksDefaultLink: 'FORM_PAGE.SETTINGS.LINKS.DEFAULT_LINK',
    linkCopyLink: 'FORM_PAGE.SETTINGS.LINKS.COPY_LINK',
    linksUseCustomDomain: 'FORM_PAGE.SETTINGS.LINKS.USE_CUSTOM_DOMAIN',
    linksSlugTitle: 'FORM_PAGE.SETTINGS.LINKS.SLUG.TITLE',
    linksSlugDescription: 'FORM_PAGE.SETTINGS.LINKS.SLUG.DESCRIPTION',
    linksSlugEnterSlug: 'FORM_PAGE.SETTINGS.LINKS.SLUG.ENTER_SLUG',
    linksSlugAvoidUsing: 'FORM_PAGE.SETTINGS.LINKS.SLUG.AVOID_USING',
    linksSlugSaveChanges: 'FORM_PAGE.SETTINGS.LINKS.SLUG.SAVE_CHANGES',
    deletionRequestDescription: 'FORM_PAGE.DELETION_REQUEST.DESCRIPTION',
    responsesDescription: 'FORM_PAGE.RESPONSES.DESCRIPTION',
    responsesBackToResponses: 'FORM_PAGE.RESPONSES.BACK_TO_RESPONSES',
    responsesDeletedResponse: 'FORM_PAGE.RESPONSES.DELETE_RESPONSE',
    responsesSubmittedAt: 'FORM_PAGE.RESPONSES.SUBMITTED_AT',
    responsesSubmittedBy: 'FORM_PAGE.RESPONSES.SUBMITTED_BY',
    responsesAnonymous: 'FORM_PAGE.RESPONSES.ANONYMOUS',
    closeForm: 'FORM_PAGE.SETTINGS.CLOSE_FORM.DEFAULT',
    closeFormDescription: 'FORM_PAGE.SETTINGS.CLOSE_FORM.DESCRIPTION',
    schedule: 'FORM_PAGE.SETTINGS.CLOSE_FORM.SCHEDULE',
    automaticallyCloseOn: 'FORM_PAGE.SETTINGS.CLOSE_FORM.AUTOMATICALLY_CLOSE_ON'
};
